import React, { Component } from 'react';
import env from "react-dotenv";
import getUserId from '../utils/getUserId';

let RATE_URL = `${env.API_URL}/rate`;
let REPORT_URL = `${env.API_URL}/report`;
let BLOCK_URL = `${env.API_URL}/block`;

const FlagIcon = () => (
  <svg style={{width: '12px', height: '12px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9" />
  </svg>
);

const UserXIcon = () => (
  <svg style={{width: '12px', height: '12px'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

class RateProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      value: 10.0,
      serverResponse: '',
      isRating: false,
      showSuccessToast: false
    };
    this.toastTimeout = null;
  }

  componentDidMount() {
    const userId = getUserId();
    if (!userId) {
      console.error('RateProfile mounted but no userId available from any source!');
    }
  }

  componentWillUnmount() {
    if (this.toastTimeout) {
      clearTimeout(this.toastTimeout);
    }
  }

  handleChange = (e) => {
    this.setState({ value: parseFloat(e.target.value) });
  };

  onSubmitRate = () => {
    const userId = getUserId();
    
    if (!userId) {
      console.error('No user ID available for rating');
      this.setState({
        serverResponse: "Please sign in to rate profiles.",
        modalIsOpen: true
      });
      return;
    }
    
    this.setState({ isRating: true });

    fetch(RATE_URL, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': env.API_KEY
      },
      body: JSON.stringify({
        rating: this.state.value,
        profile_id: this.props.Id
      })
    })
      .then(async (response) => {
        let data;

        try {
          data = await response.json();
        } catch (err) {
          data = null;
        }

        if (!response.ok) {
          this.setState({
            serverResponse: "Error submitting rating.",
            modalIsOpen: true,
            isRating: false
          });
          return;
        }

        const msg =
          data?.message ||
          data?.status ||
          data?.result ||
          (typeof data === "string" ? data : "");

        const messageStr = String(msg).toLowerCase();

        const isAlreadyRated =
          messageStr.includes("already rated") ||
          messageStr.includes("already") ||
          data?.already === true;

        if (isAlreadyRated) {
          this.setState({
            serverResponse: "Already rated this profile",
            modalIsOpen: true,
            isRating: false
          });
        } else {
          this.setState({
            showSuccessToast: true,
            isRating: false
          });
          
          this.toastTimeout = setTimeout(() => {
            if (this.toastTimeout) {
              this.setState({ showSuccessToast: false });
            }
          }, 2000);
          
          if (this.props.onRatingSubmitted) {
            this.props.onRatingSubmitted();
          }
          
          if (this.props.setTest) {
            this.props.setTest(this.state.value);
          }
        }
      })
      .catch((error) => {
        console.error('RATE ERROR:', error);
        this.setState({
          serverResponse: "Error submitting rating.",
          modalIsOpen: true,
          isRating: false
        });
      });
  };

  onSubmitReport = () => {
    const userId = getUserId();
    
    if (!userId) {
      console.error('No user ID available for reporting');
      this.setState({
        serverResponse: "Please sign in to report profiles.",
        modalIsOpen: true
      });
      return;
    }
    
    fetch(REPORT_URL, {
      method: 'post',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': env.API_KEY
      },
      body: JSON.stringify({
        profile_id: this.props.Id
      })
    })
      .then(response => response.json())
      .then(data => {
        if(data) {
          this.setState({
            serverResponse: 'Profile reported. Thank you for keeping our community safe.',
            modalIsOpen: true
          });
          
          if (this.props.onRatingSubmitted) {
            setTimeout(() => {
              this.props.onRatingSubmitted();
            }, 500);
          }
        }
      })
      .catch(error => {
        console.error('Error reporting profile:', error);
      });
  };

  onSubmitBlock = () => {
    const userId = getUserId();
    
    if (!userId) {
      console.error('No user ID available for blocking');
      this.setState({
        serverResponse: "Please sign in to block users.",
        modalIsOpen: true
      });
      return;
    }
    
    fetch(BLOCK_URL, {
      method: 'post',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': env.API_KEY
      },
      body: JSON.stringify({
        profile_id: this.props.Id,
        blocked: true
      })
    })
      .then(response => response.json())
      .then(data => {
        if(data) {
          this.setState({
            serverResponse: 'User blocked successfully.',
            modalIsOpen: true
          });
          
          if (this.props.onRatingSubmitted) {
            setTimeout(() => {
              this.props.onRatingSubmitted();
            }, 500);
          }
        }
      })
      .catch(error => {
        console.error('Error blocking user:', error);
      });
  };

  getRatingText = (val) => {
    if (val < 3) return 'Not Great';
    if (val < 5) return 'Okay';
    if (val < 7) return 'Good';
    if (val < 9) return 'Great';
    return 'Amazing!';
  };

  render() {
    const { value, modalIsOpen, serverResponse, isRating, showSuccessToast } = this.state;

    return (
      <>
        <div className="rate-profile-container">
          {/* Rating Display */}
          <div className="rating-display">
            <div className="rating-circle">
              <span className="rating-value">{value.toFixed(1)}</span>
            </div>
            <p className="rating-text">{this.getRatingText(value)}</p>
          </div>

          {/* Slider */}
          <div className="slider-container">
            <input
              type="range"
              min="0"
              max="10"
              step="0.1"
              value={value}
              onChange={this.handleChange}
              className="rating-slider"
            />
            <div className="slider-labels">
              <span>0</span>
              <span>5</span>
              <span>10</span>
            </div>
          </div>

          {/* Submit Button */}
          <button
            onClick={this.onSubmitRate}
            disabled={isRating}
            className="submit-btn"
          >
            {isRating ? (
              <>
                <div className="spinner"></div>
                <span>Submitting...</span>
              </>
            ) : (
              <span>Submit Rating</span>
            )}
          </button>

          {/* Action Buttons - Always Visible */}
          <div className="action-buttons">
            <button onClick={this.onSubmitReport} className="action-btn report-btn" type="button">
              <FlagIcon />
              <span>Report Inappropriate</span>
            </button>
            
            <button onClick={this.onSubmitBlock} className="action-btn block-btn" type="button">
              <UserXIcon />
              <span>Block User</span>
            </button>
          </div>
        </div>

        {/* NEW: Success Toast - subtle, non-blocking feedback */}
        {showSuccessToast && (
          <div className="success-toast">
            <svg className="toast-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            <span>Rating updated!</span>
          </div>
        )}

        {/* Modal - Only for errors, "already rated", and actions like report/block */}
        {modalIsOpen && (
          <div className="modal-overlay" onClick={() => this.setState({ modalIsOpen: false })}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-icon">
                <svg className="checkmark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="modal-title">Success!</h3>
              <p className="modal-message">{serverResponse}</p>
              <button onClick={() => this.setState({ modalIsOpen: false })} className="modal-close-btn">
                Close
              </button>
            </div>
          </div>
        )}

        <style>{`
          .rate-profile-container {
            padding: 16px;
            background: white;
            border-radius: 8px;
          }

          .rating-display {
            text-align: center;
            margin-bottom: 20px;
          }

          .rating-circle {
            width: 80px;
            height: 80px;
            margin: 0 auto 12px;
            border-radius: 50%;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
          }

          .rating-value {
            font-size: 32px;
            font-weight: bold;
            color: white;
          }

          .rating-text {
            font-size: 14px;
            color: #6b7280;
            font-weight: 500;
            margin: 0;
          }

          .slider-container {
            margin-bottom: 20px;
          }

          .rating-slider {
            width: 100%;
            height: 6px;
            border-radius: 3px;
            background: linear-gradient(to right, 
              #3b82f6 0%, 
              #1d4ed8 ${value * 10}%, 
              #e5e7eb ${value * 10}%, 
              #e5e7eb 100%);
            outline: none;
            -webkit-appearance: none;
            cursor: pointer;
          }

          .rating-slider::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            cursor: pointer;
            box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4);
            transition: transform 0.2s;
          }

          .rating-slider::-webkit-slider-thumb:hover {
            transform: scale(1.2);
          }

          .rating-slider::-moz-range-thumb {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            cursor: pointer;
            border: none;
            box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4);
            transition: transform 0.2s;
          }

          .rating-slider::-moz-range-thumb:hover {
            transform: scale(1.2);
          }

          .slider-labels {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            color: #9ca3af;
            margin-top: 4px;
          }

          .submit-btn {
            width: 100%;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 8px;
            font-weight: 600;
            font-size: 13px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            transition: all 0.2s;
            box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
          }

          .submit-btn:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }

          .submit-btn:active:not(:disabled) {
            transform: translateY(0);
          }

          .submit-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .spinner {
            width: 16px;
            height: 16px;
            border: 2px solid white;
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 0.6s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          .action-buttons {
            margin-top: 6px;
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .action-btn {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            padding: 6px 10px;
            border-radius: 6px;
            font-weight: 500;
            font-size: 11px;
            cursor: pointer;
            transition: all 0.2s;
            border: 1.5px solid;
          }

          .report-btn {
            background: white;
            color: #ea580c;
            border-color: #fed7aa;
          }

          .report-btn:hover {
            background: #fff7ed;
          }

          .block-btn {
            background: white;
            color: #dc2626;
            border-color: #fecaca;
          }

          .block-btn:hover {
            background: #fef2f2;
          }

          /* NEW: Success Toast - subtle, non-blocking feedback */}
          .success-toast {
            position: fixed;
            bottom: 24px;
            left: 50%;
            transform: translateX(-50%);
            background: linear-gradient(135deg, #34d399, #10b981);
            color: white;
            padding: 12px 20px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
            z-index: 1001;
            font-weight: 600;
            font-size: 14px;
            animation: slideUp 0.3s ease-out;
          }

          .toast-icon {
            width: 20px;
            height: 20px;
            stroke-width: 2.5;
          }

          @keyframes slideUp {
            from {
              transform: translateX(-50%) translateY(20px);
              opacity: 0;
            }
            to {
              transform: translateX(-50%) translateY(0);
              opacity: 1;
            }
          }

          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            backdrop-filter: blur(4px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            padding: 16px;
            animation: fadeIn 0.2s;
          }

          .modal-content {
            background: white;
            border-radius: 20px;
            padding: 32px;
            max-width: 400px;
            width: 100%;
            text-align: center;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
            animation: zoomIn 0.2s;
          }

          .modal-icon {
            width: 64px;
            height: 64px;
            background: linear-gradient(135deg, #34d399, #10b981);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 20px;
          }

          .checkmark {
            width: 32px;
            height: 32px;
            color: white;
          }

          .modal-title {
            font-size: 24px;
            font-weight: bold;
            color: #111827;
            margin: 0 0 12px 0;
          }

          .modal-message {
            color: #6b7280;
            margin: 0 0 24px 0;
            line-height: 1.5;
          }

          .modal-close-btn {
            width: 100%;
            background: linear-gradient(135deg, #3b82f6, #1d4ed8);
            color: white;
            border: none;
            padding: 12px 24px;
            border-radius: 12px;
            font-weight: 600;
            font-size: 15px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .modal-close-btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes zoomIn {
            from {
              transform: scale(0.95);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}</style>
      </>
    );
  }
}

export default RateProfile;